import type React from 'react';
import { SliceImageButton } from '../common/SliceImageButton';
import { useInjection } from 'inversify-react';
import { TYPES as ImagesTYPES } from '@/engine/app/modules/images/iocTypes';
import { ReactComponent as ResetContrastIcon } from './icons/reset_contrast.svg';
import type { ImagesService } from '@/engine/app/modules/images/Images.service';

export const ResetContrast: React.FC<{
  descriptor: string;
  isMaximized?: boolean;
}> = ({ descriptor, isMaximized }) => {
  const imagesService = useInjection<ImagesService>(ImagesTYPES.ImagesService);

  return (
    <SliceImageButton
      className={`resetContrast-icon ${descriptor}-resetContrast ${isMaximized ? 'maximized' : 'minimized'}`}
      onClick={(): void => imagesService.resetContrast()}
      data-testid="resetContrastBtn"
      $isMaximized={isMaximized}
      $isActive={false}
    >
      <ResetContrastIcon style={{ height: 24, width: 24 }} />
    </SliceImageButton>
  );
};
